import eventBus from 'common/event-handling/event-bus.model';
import {
  PreloadedEvent,
  PreloadErrorEvent
} from 'common/event-handling/events';
import * as React from 'react';
import { StoreContext } from '../../store';
import { ExperiencePlayer } from '../../../../creative-tag/lib/components/experience-player';
import { CreativeTagEvent } from '../../../../creative-tag/lib/enums/creative-tag-event.enum';

interface Props {
  onClick?: (e: ClickEvent) => unknown;
  containerClassName?: string;
  containerStyle?: React.CSSProperties;
  imageStyle?: React.CSSProperties;
  imageClassName?: string;

  creativeUrl?: string;
  blurCreativeUrl?: string;
}

export const Creative = React.memo(
  ({
    imageClassName,
    imageStyle,
    containerClassName,
    containerStyle,
    creativeUrl,
    blurCreativeUrl,
    onClick
  }: Props) => {
    const rootStore = React.useContext(StoreContext);
    const { creative, blurEffect } = rootStore.formatConfig;

    const computedCreativeUrl = creativeUrl || creative.url;
    const creativeDomRef = React.useRef(null);

    const expPlayer = new ExperiencePlayer();

    React.useEffect(() => {
      const experienceOptions = {
        window,
        container: (creativeDomRef.current as unknown) as HTMLDivElement,
        adContext: rootStore.adContext,
        creativeProps: {
          isVertical: rootStore.creativeStore.isVertical,
          blurEffect,
          blurCreativeUrl: blurCreativeUrl || creativeUrl,
          containerClassName,
          containerStyle,
          imageClassName,
          imageStyle,
          creativeUrl: computedCreativeUrl,
          ...(rootStore.adContext?.clickArea && {
            clickArea: rootStore.adContext.clickArea
          }),
          ...(rootStore.adContext?.fitStrategy && {
            fitStrategy: rootStore.adContext.fitStrategy
          }),
          ...(rootStore.adContext?.backgroundColor && {
            backgroundColor: rootStore.adContext.backgroundColor
          })
        }
      };

      expPlayer.addEventListener(CreativeTagEvent.CREATIVE_ASSET_LOAD, () =>
        eventBus.publish(new PreloadedEvent())
      );
      expPlayer.addEventListener(CreativeTagEvent.CREATIVE_LOADING_FAILED, () =>
        eventBus.publish(new PreloadErrorEvent())
      );
      expPlayer.addEventListener(CreativeTagEvent.CREATIVE_CLICKED, evt => {
        if (!evt) return;

        if (onClick) {
          onClick((evt as unknown) as ClickEvent);
        } else {
          rootStore.userClickHandler.handle((evt as unknown) as ClickEvent);
        }
      });
      expPlayer.startExperience(experienceOptions);
    }, []);

    return (
      <div ref={creativeDomRef} style={{ width: '100%', height: '100%' }}></div>
    );
  }
);
